webpackJsonp([21857691331462],{

/***/ 572:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/ml"}}

/***/ })

});


// WEBPACK FOOTER //
// path---ml-8d3bbc943142c305edf4.js